<div *ngIf="visible && item" class="mini-cart-toast">
  <div class="mini-cart-head d-flex align-items-center gap-2 mb-5">
    <h5 class="title fw-normal">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16 5.5L7.75 13.75L4 10"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Item added to cart
    </h5>
    <button
      class="btn btn-secondary-icon shadow-none ms-auto"
      (click)="close()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
      >
        <path
          d="M11.5422 0.742188L0.742188 11.5422M0.742188 0.742188L11.5422 11.5422"
          stroke="#36394A"
          stroke-width="1.485"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>

  <div class="added-cart-item">
    <div class="product-image">
      <img
        [src]="
          item.product.imageUrl || 'https://placehold.co/100x100?text=No+Image'
        "
        alt="product"
      />
    </div>

    <div class="flex-grow-1">
      <h5 class="product-title fw-bold">
        {{ item.product.name || "Ladies Denim Stretch Jeans" }}
      </h5>
      <p class="product-code">
        <span class="text-secondary fw-normal">Code:</span>
        {{ item.product.code || "BMD Pants" }}
      </p>

      <!-- <div class="d-flex align-items-center mb-2">
        <div class="d-flex align-items-center gap-2 pe-2 me-2 border-end fs-5">
          <span class="label">Color:</span>
          <span class="d-flex gap-2 align-items-center">
            <span
              class="product-color"
              [style.background]="item.variation.colour || '#000'"
            >
            </span>

            <span class="text-black fs-5">{{
              item.variation.colour || "Black"
            }}</span>
          </span>
        </div>

        <div class="text-secondary pe-2 me-2 border-end fs-5">
          <span class="label">Size:</span>
          <span class="text-black fs-5">
            {{ item.variation.size || "Medium" }}
          </span>
        </div>

        <div class="text-secondary fs-5">
          <span class="label">Quantity:</span>
          <span class="text-black fs-5">
            {{ item.quantity || 1 }}
          </span>
        </div>
      </div> -->
    </div>
  </div>

  <div class="d-flex gap-3 flex-column justify-content-center align-items-center gap-2">
    <button
      class="btn btn-secondary w-100"
      routerLink="/cart"
      (click)="close()"
    >
      View my cart ({{ cartService.cart.itemCount || 0}})
    </button>
    <a routerLink="/cart/checkout" (click)="close()" class="btn btn-primary text-white w-100">
      Checkout
    </a>
    <a
      (click)="close()"
      routerLink="/products"
      class="btn btn-secondary w-100 border-none shadow-none"
    >
      Continue Shopping
    </a>
  </div>
</div>
